/* Third party libraries */
import axios from 'axios';
import type { WidgetDataInterface } from '@/components/Widgets/types';

import type { TDMAnalytics } from '../types/Analytics';
import { baseUrl, HttpMethods } from './base';

// Generated by https://quicktype.io

const analyticsBasePath = `${baseUrl.SHERPA}/analytics`;

export interface GetTdmAnalyticsResponse {
  data: Data;
}

export interface Data {
  tasks: TDMAnalytics[];
  deliverables: TDMAnalytics[];
  milestones: TDMAnalytics[];
}

export async function getUserTdmAnalytics(userId: number) {
  const resp = await axios.get<GetTdmAnalyticsResponse>(`${analyticsBasePath}/tdm?user_id=${userId}&projects_archived=false`);
  return resp.data.data;
}

export async function getCompanyTdmAnalytics() {
  const resp = await axios.get<GetTdmAnalyticsResponse>(`${analyticsBasePath}/tdm?projects_archived=false`);
  return resp.data.data;
}

export async function getProjectTdmAnalytics(projectId: number) {
  const resp = await axios.get<GetTdmAnalyticsResponse>(`${analyticsBasePath}/tdm?project_id=${projectId}`);
  return resp.data.data;
}

export interface GetTdmAnalyticsParams {
  user_id?: number;
  project_id?: number;
  phase?: string;
  projects_archived?: string;
}

export async function getTdmAnalytics(params: GetTdmAnalyticsParams) {
  const resp = await axios.get<GetTdmAnalyticsResponse>(`${analyticsBasePath}/tdm`, { params });
  return resp.data.data;
}

export interface GetCompanyProjectsAnalyticsParams {
  params?: { [key: string]: string };
}

export async function getProjectsAnalytics({ params }: GetCompanyProjectsAnalyticsParams) {
  const res = await axios({
    method: HttpMethods.GET,
    url: `${analyticsBasePath}/dashboard`,
    params,
  });

  return res.data;
}

export async function getWidgetsList() {
  const res = await axios.request({
    method: 'GET',
    url: `${baseUrl.SHERPA}/widgets`,
  });
  return res.data;
}

/* Widget Interface  */

export interface WidgetList {
  widgetId: number;
  locationId: number;
}

export interface PostWidgetsListInterface {
  widgets: WidgetList[];
  dashboardType: string;
}

export async function postWidgetsList(props: PostWidgetsListInterface) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/widgets`,
    data: props,
  });
  return res.data;
}

export interface DashboardWidgetData extends WidgetDataInterface {
  data: unknown;
}

export interface GetDashboardDataResponse {
  data: DashboardWidgetData[];
}

export async function getDashboardData(dashboardType: string) {
  const res = await axios.request<GetDashboardDataResponse>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/widgets/data?dashboardType=${dashboardType}`,
  });
  return res.data;
}

export interface PostClientWidgetInterface {
  widgetId: number;
  accountId: number;
}
export async function postClientWidget(props: PostClientWidgetInterface) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/widgets/account`,
    data: props,
  });
  return res.data;
}

export async function deleteClientWidget(props: PostClientWidgetInterface) {
  const res = await axios.request({
    method: HttpMethods.DELETE,
    url: `${baseUrl.SHERPA}/widgets/account`,
    data: props,
  });
  return res.data;
}

export async function getClientWidgetsList(id?: number) {
  const res = await axios.request({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/widgets?accountId=${id}`,
  });
  return res.data;
}
